<script setup lang="ts">
import "@/assets/css/_main.css";
</script>

<template>
  <div class="wp-min-h-screen flex flex-col [&>main]:grow">
    <slot />
  </div>
</template>
